import { memo } from "react";

const Paragraph = memo((props: any) => {
  return <p {...props.attributes}>{props.children}</p>;
});

export { Paragraph };
